import { createClient } from "@supabase/supabase-js";
import { defu } from "defu";
import { useSupabaseToken } from "./useSupabaseToken.mjs";
import { useRuntimeConfig, useNuxtApp } from "#imports";
export const useSupabaseClient = () => {
  const nuxtApp = useNuxtApp();
  const token = useSupabaseToken();
  const Authorization = token.value ? `Bearer ${token.value}` : void 0;
  const { supabase: { url, key, client: clientOptions } } = useRuntimeConfig().public;
  const options = Authorization ? defu(clientOptions, { global: { headers: { Authorization } } }) : clientOptions;
  const recreateClient = nuxtApp._supabaseClient?.headers.Authorization !== Authorization;
  if (!nuxtApp._supabaseClient || recreateClient) {
    nuxtApp._supabaseClient = createClient(url, key, options);
  }
  return nuxtApp._supabaseClient;
};
